import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { getProceedToAnalysis } from "../../network/cipAPI";

import DupontDialog from "../../components/DupontDialog";

import createNotification, {
  ERROR_NOTIFICATION,
} from "../../components/Notifications";

import "./index.scss";
import { API_URLS } from "../../network/appUrls";

//const isLocalhost = window.location.hostname === "localhost";
//const basePath = isLocalhost ? "/" : "/roadvisor/";
//const basePath = isLocalhost ? "/" : window.location.origin;
const basePath = API_URLS.basePath;

const NormalizationCheck = ({
  isNormalizationPopUpOpen,
  setIsNormalizationPopUpOpen,
  plantId,
  fileId,
  selectedTrain,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [showOverLayLoader, setShowOverLayLoader] = useState(false);

  const handleConfirm = async () => {
    try {
      setShowOverLayLoader(true);
      const response = await getProceedToAnalysis(fileId, selectedTrain);

      if (response && response.status === 200) {
        const path = `${basePath}home?plantId=${plantId}`;
        navigate(path);
      } else {
        createNotification(ERROR_NOTIFICATION, response.data.detail.error, "");
      }
    } catch (error) {
      createNotification(
        ERROR_NOTIFICATION,
        t("notificationStrings.somethingWrong"),
        ""
      );
      setShowOverLayLoader(false);
      console.log("onClose", error);
    } finally {
      setShowOverLayLoader(false);
      setIsNormalizationPopUpOpen(false);
    }
  };

  const onClose = (action) => {
    if (action === "CONFIRM") {
      handleConfirm();
    } else if (action === "CANCEL") {
      setShowOverLayLoader(false);
      setIsNormalizationPopUpOpen(false);
    }
  };

  return (
    <DupontDialog
      open={isNormalizationPopUpOpen}
      onClose={onClose}
      title={t("analyseData.normalizationCheck")}
      cancelBtnText={t("ValueStrings.cancel")}
      confirmBtnText={t("ValueStrings.confirm")}
      maxwidth="xl"
      minWidth={775}
      isOverlayLoader={showOverLayLoader}
      customHeight={"260px"}
    >
      <div className="lightGrayBorder padding10 descriptionText font-14 ">
        <div className=" flex-between  position-relative ">
          <div className="margin-top-10 ">
            {t("analyseData.normalizationDescription")}
          </div>
        </div>
      </div>
    </DupontDialog>
  );
};
export default NormalizationCheck;
